/*
  IW Nuevo product page buy box (phase 2.2, T14 and T15). Loaded by snippets/buy-buttons.liquid for the main product section.

  Variant refresh (T15): product-info.js swaps only the price, SKU, inventory and quantity rules when the shopper picks
  another variant. Everything that depends on the variant but lives elsewhere is printed inside a stable slot
  ([data-iw-live], one id per section: installments, delivery card, trust box, sold-out note). After each change this
  file replaces the content of every slot with the one from the section HTML that product-info.js just fetched, so
  those blocks follow the selected variant (a sold-out variant has no delivery promise, a variant on pre-order has its own).

  Mobile sticky buy bar (.iw-sticky-buy, drawn by assets/iw-pdp.css):
  - It shows whenever the real add-to-cart row is off screen: below the fold when the page opens (so the price and
    "Agregar" are on the first screen, Nico 2026-10-23) and after it has scrolled past the top. It hides while the
    row is in view. The position is read on scroll instead of with an IntersectionObserver, which stays silent
    when a fast scroll jumps over the row without ever showing it.
  - It stays hidden while the selected variant cannot be bought (the real submit button is disabled).
  - "Agregar" clicks the real submit button, so the item added is always the variant selected in the form.
  - When the variant changes, product-info.js publishes "variant-change" after it has swapped the price element,
    so the bar copies the new price from there and takes the variant's own image for the thumbnail.
*/
(function () {
  function init(bar) {
    if (bar.dataset.iwBuyBoxReady) return;
    bar.dataset.iwBuyBoxReady = 'true';

    const sectionId = bar.id.replace('StickyBuy-', '');
    const root = bar.closest('product-info') || document;
    const realButton = () => root.querySelector('#ProductSubmitButton-' + sectionId);
    const anchor = root.querySelector('.product-form__buttons');
    const trigger = bar.querySelector('[data-sticky-buy-trigger]');
    const thumb = bar.querySelector('.iw-sticky-buy__thumb');
    const price = bar.querySelector('[data-sticky-buy-price]');
    const button = realButton();
    if (!button || !anchor || !trigger) return;

    let offScreen = false;
    let ticking = false;

    function render() {
      const real = realButton();
      const canBuy = Boolean(real) && !real.disabled;
      trigger.disabled = !canBuy;
      bar.classList.toggle('is-visible', offScreen && canBuy);
    }

    function update() {
      ticking = false;
      const rect = anchor.getBoundingClientRect();
      offScreen = rect.bottom <= 0 || rect.top >= window.innerHeight;
      render();
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    trigger.addEventListener('click', () => {
      const real = realButton();
      if (real && !real.disabled) real.click();
    });

    new MutationObserver(render).observe(button, { attributes: true, attributeFilter: ['disabled'] });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data.sectionId) !== sectionId) return;

        const priceElement = root.querySelector('#price-' + sectionId + ' .price');
        if (priceElement && price) {
          const selector = priceElement.classList.contains('price--on-sale')
            ? '.price__sale .price-item--sale'
            : '.price__regular .price-item--regular';
          const text = priceElement.querySelector(selector)?.textContent.trim();
          if (text) price.textContent = text;
        }

        const src = data.variant?.featured_image?.src;
        if (thumb && src) {
          thumb.removeAttribute('srcset');
          thumb.src = src + (src.includes('?') ? '&' : '?') + 'width=104';
        }
        render();
      });
    }

    update();
  }

  function refreshSlots(sectionId, html) {
    const root = document.querySelector('product-info[data-section="' + sectionId + '"]');
    if (!root || !html) return;

    let deliveryChanged = false;
    root.querySelectorAll('[data-iw-live]').forEach((slot) => {
      const next = html.getElementById(slot.id);
      if (!next) return;

      // The shipping details are a <details>: keep it open if the shopper had opened it.
      const wasOpen = Boolean(slot.querySelector('details[open]'));
      slot.innerHTML = next.innerHTML;
      if (wasOpen) slot.querySelector('details')?.setAttribute('open', '');
      if (slot.id.indexOf('IwDelivery') === 0) deliveryChanged = true;
    });

    // delivery-cutoff.js fills the countdown and the date text: ask it to read the new markup right away.
    if (deliveryChanged) document.dispatchEvent(new CustomEvent('iw:delivery-refresh'));
  }

  // One subscription per page, even if the script tag is evaluated again after a product swap.
  if (!window.iwBuyBoxLiveSlots && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    window.iwBuyBoxLiveSlots = true;
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => refreshSlots(String(data.sectionId), data.html));
  }

  document.querySelectorAll('[data-sticky-buy]').forEach(init);
})();
